import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withPreloading } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { DialogService } from 'primeng/dynamicdialog';
import Aura from '@primeng/themes/aura';

import { routes } from './app.routes';
import { callInterceptor } from './core/interceptors/call-interceptor';
import { retryInterceptor } from './core/interceptors/retry.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { quotaInterceptor } from './core/interceptors/quota.interceptor';
import { LocalAiDesktopSyncService } from './features/Settings/local-ai/services/local-ai-desktop-sync.service';
import { SelectivePreloadingStrategy } from './core/router/selective-preloading.strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    DialogService,
    provideRouter(routes, withPreloading(SelectivePreloadingStrategy)),
    provideHttpClient(withInterceptors([errorInterceptor, callInterceptor, retryInterceptor, quotaInterceptor])),
    // Desktop-only background sync: keeps Local AI tunnel endpoints + worker
    // heartbeats fresh across app restarts. No-op in the web app.
    provideAppInitializer(() => {
      inject(LocalAiDesktopSyncService).start();
    }),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: 'system',
          cssLayer: false
        }
      }
    })
  ]
};
